import React, { FC, ReactElement } from "react";
import { Helmet } from "react-helmet";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import GetStartedContent from "../components/home/aboutUs"

import HomeContent from "../components/home/homeContent"

// components
import PageTitle from "../components/ui/pageTitle";

// constants
import { APP_TITLE, PAGE_TITLE_HOME } from "../helpers/constants";

// define css-in-js
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flex: 1,
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
  })
);

const Home: FC<{}> = (): ReactElement => {
  const classes = useStyles();
  return (
    <>
      <Helmet>
        <title>
          {PAGE_TITLE_HOME} | {APP_TITLE}
        </title>
      </Helmet>
      <div className={classes.root}>
        <PageTitle title={PAGE_TITLE_HOME} />
      
      </div>
      <HomeContent/>

    </>
  );
};

export default Home;
